import { forwardRef } from 'react';
import { IconProps } from '../iconTypes';
const SVGIcon = forwardRef<SVGSVGElement, IconProps>(({
  size = 14,
  ...props
}, svgRef) => {
  if (size) {
    props.width = size;
    props.height = size;
  }
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true" viewBox="0 0 512 512" ref={svgRef} {...props}><path d="M149.6 234.4c20.9-6.7 43.2-10.4 66.4-10.4h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-25.4 0-49.5 5.6-71 15.7C152.7 351 206.6 400 271.9 400h1c97.3-.5 191.1-100.3 191.1-243.4 0-12.8-.8-25.3-2.3-37.5C437 134.9 407.6 144 376 144H272c-57.6 0-106.3 38.1-122.4 90.4zm-53.2 25.7C102.5 168.5 178.8 96 272 96h104c28.7 0 54.8-10.8 74.6-28.5.7-.6 1.4-1.3 2.1-1.9 6.6-6.2 12.5-13.2 17.4-20.9 1.6-2.5 3.2-5.1 4.6-7.8 3.5-6.5 13.6-6.8 16.2.1 1.3 3.5 2.5 7 3.7 10.6 2.9 8.9 5.5 17.9 7.8 27.2.5 1.9.9 3.8 1.3 5.6 5.4 24.3 8.3 49.8 8.3 76.2 0 160.5-106.9 290.7-239 291.4h-1c-81.7 0-150.4-55.7-170.2-131.2C68.7 347.5 48 391.3 48 440v16c0 13.3-10.7 24-24 24S0 469.3 0 456v-16c0-75.1 38.3-141.2 96.4-179.9z" /></svg>;
});
SVGIcon.displayName = "RegularLeaf";
export default SVGIcon;